export default {
  init() {
    // JavaScript to be fired on all pages
    // Shrinking header
    if ($(window).width() > 992) { // desktop
        $(window).scroll(function() {
            if ($(document).scrollTop() > 5) {
              $('.site-header').addClass('shrink');
            } else {
              $('.site-header').removeClass('shrink');
            }
        });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */


    var $hamburger = $(".hamburger");
      $hamburger.on("click", function(e) {
        $hamburger.toggleClass("is-active");
        $("body").toggleClass("menu-opened");
        $(".header__wrapper-overlay-menu").toggleClass("opened");
        $(".brand").toggleClass("logo-show");
      });


      // height matching elements
        $(document).ready(function(){
            $('#gallery-grid .grid-item .card').matchHeight({byRow:false});
        });
        $(window).resize(function() {
            $('#gallery-grid .grid-item .card').matchHeight({byRow:false});
        });
        

        // Target your .container, .wrapper, .post, etc.
        $(".video-container").fitVids();


        //AOS.init();


        $('.cbp-link').click(function(e) {
            e.preventDefault();
            window.open($(this).attr('href'), 'ShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            return false;
        });


    $(document).ready(function(){
        if ($(window).width() > 991) { // desktop

                $('.page-scroll').bind('click', function(event) {
                    var $anchor = $(this);
                    $('html, body').stop().animate({
                        scrollTop: $($anchor.attr('href')).offset().top -95
                    }, 600, 'easeInOutExpo');
                    event.preventDefault();
                });

                // to top right away
                if ( window.location.hash ) scroll(0,0);
                // void some browsers issue
                setTimeout( function() { scroll(0,0); }, 1);

                $(function() {
                    // *only* if we have anchor on the url
                    if(window.location.hash) {
                        // smooth scroll to the anchor id
                        $('html, body').stop().animate({
                            scrollTop: $(window.location.hash).offset().top -65
                        }, 600, 'easeInOutExpo');
                    }
                });

                $('#grade-scroll select').prop('selectedIndex',0);

                $('#grade-scroll select').on('change',function (e) {
                    e.preventDefault(); // no need to use this line
                    var target = $(this).val();
                    var $target = $(target);

                    if ($target.length > 0) {
                        $('html, body').animate({
                            'scrollTop': $target.offset().top -68
                        }, 1200, 'easeInOutExpo', function () {  // swing here will work if you include jquery-ui  without that it will not make a effect
                            //window.location.hash = target;
                        });
                    }

                }).change();


        } else { // mobile

                $('.page-scroll').bind('click', function(event) {
                    var $anchor = $(this);
                    $('html, body').stop().animate({
                        scrollTop: $($anchor.attr('href')).offset().top -1
                    }, 600, 'easeInOutExpo');
                    event.preventDefault();
                });

                // to top right away
                // if ( window.location.hash ) scroll(0,0);
                // // void some browsers issue
                // setTimeout( function() { scroll(0,0); }, 1);

                // $(function() {
                //     // *only* if we have anchor on the url
                //     if(window.location.hash) {
                //         // smooth scroll to the anchor id
                //         $('html, body').stop().animate({
                //             scrollTop: $(window.location.hash).offset().top -1
                //         }, 600, 'easeInOutExpo');
                //     }
                // });


                $('#grade-scroll select').prop('selectedIndex',0);
                
                $('#grade-scroll select').on('change',function (e) {
                    e.preventDefault(); // no need to use this line
                    var target = $(this).val();
                    var $target = $(target);

                    if ($target.length > 0) {
                        $('html, body').animate({
                            'scrollTop': $target.offset().top -1
                        }, 1200, 'easeInOutExpo', function () {  // swing here will work if you include jquery-ui  without that it will not make a effect
                            //window.location.hash = target;
                        });
                    }
                }).change();

        }

    });
    $(window).resize(function() {
        if ($(window).width() > 991) { // desktop

                $('.page-scroll').bind('click', function(event) {
                    var $anchor = $(this);
                    $('html, body').stop().animate({
                        scrollTop: $($anchor.attr('href')).offset().top -65
                    }, 600, 'easeInOutExpo');
                    event.preventDefault();
                });

                // to top right away
                // if ( window.location.hash ) scroll(0,0);
                // // void some browsers issue
                // setTimeout( function() { scroll(0,0); }, 1);

                // $(function() {
                //     // *only* if we have anchor on the url
                //     if(window.location.hash) {
                //         // smooth scroll to the anchor id
                //         $('html, body').stop().animate({
                //             scrollTop: $(window.location.hash).offset().top -65
                //         }, 600, 'easeInOutExpo');
                //     }
                // });

                $('#grade-scroll select').prop('selectedIndex',0);

                $('#grade-scroll select').on('change',function (e) {
                    e.preventDefault(); // no need to use this line
                    var target = $(this).val();
                    var $target = $(target);

                    if ($target.length > 0) {
                        $('html, body').animate({
                            'scrollTop': $target.offset().top -68
                        }, 1200, 'easeInOutExpo', function () {  // swing here will work if you include jquery-ui  without that it will not make a effect
                            //window.location.hash = target;
                        });
                    }

                }).change();


        } else { // mobile

                $('.page-scroll').bind('click', function(event) {
                    var $anchor = $(this);
                    $('html, body').stop().animate({
                        scrollTop: $($anchor.attr('href')).offset().top -1
                    }, 600, 'easeInOutExpo');
                    event.preventDefault();
                });

                // to top right away
                // if ( window.location.hash ) scroll(0,0);
                // // void some browsers issue
                // setTimeout( function() { scroll(0,0); }, 1);

                // $(function() {
                //     // *only* if we have anchor on the url
                //     if(window.location.hash) {
                //         // smooth scroll to the anchor id
                //         $('html, body').stop().animate({
                //             scrollTop: $(window.location.hash).offset().top -1
                //         }, 600, 'easeInOutExpo');
                //     }
                // });


                $('#grade-scroll select').prop('selectedIndex',0);
                
                $('#grade-scroll select').on('change',function (e) {
                    e.preventDefault(); // no need to use this line
                    var target = $(this).val();
                    var $target = $(target);

                    if ($target.length > 0) {
                        $('html, body').animate({
                            'scrollTop': $target.offset().top -1
                        }, 1200, 'easeInOutExpo', function () {  // swing here will work if you include jquery-ui  without that it will not make a effect
                            //window.location.hash = target;
                        });
                    }
                }).change();

        }

    });



    /* eslint-enable */


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js